import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Create axios instance
const api = axios.create({
    baseURL: `${API_URL}`,
    withCredentials: true
});

// Add auth token to all requests + normalize API paths
api.interceptors.request.use((config) => {
    // The backend serves every route under /api. Dozens of call sites omit the
    // prefix (api.get('/users/profile')) and silently 404 — normalize here so
    // both styles work and future call sites can't regress.
    if (config.url && config.url.startsWith('/') && !config.url.startsWith('/api/') && config.url !== '/api') {
        config.url = `/api${config.url}`;
    }
    // Don't clobber an explicitly provided token (e.g. admin_token from admin pages)
    const token = localStorage.getItem('token');
    if (token && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// Handle 401 responses globally
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Token expired or invalid
            localStorage.removeItem('token');
            // Optionally redirect to login
            if (window.location.pathname !== '/login' && 
                window.location.pathname !== '/signup' &&
                window.location.pathname !== '/') {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;
